import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/circle-info.svg'
@Component({
  tag: 'cr-icon-circle-info',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconCircleInfo {
  /**
    * The size of the icon - can be 'small', 'medium' or 'large'
    */
  @Prop() size: string
  @Prop() disabled: boolean
  render() {
    return (
      <div
        part='cr-icon'
        class={`${this.size} ${this.disabled ? 'disabled' : ''}`}
        innerHTML={Icon}
      />
    );
  }

}
